export const REGION_LABELS = {
    1:'qc-region-1-label',
    2:'qc-region-2-label',
    3:'qc-region-3-label',
    4:'qc-region-4-label',
    5:'qc-region-5-label',
    6:'qc-region-6-label',
    7:'qc-region-7-label',
    8:'qc-region-8-label',
    9:'qc-region-9-label',
    10:'qc-region-10-label',
    11:'qc-region-11-label',
    12:'qc-region-12-label',
    13:'qc-region-13-label',
    14:'qc-region-14-label',
    15:'qc-region-15-label',
    16:'qc-region-16-label',
    17:'qc-region-17-label',
    101:'on-region-1-label',
    102:'on-region-2-label',
    103:'on-region-3-label',
    104:'on-region-4-label',
    105:'on-region-5-label',
    106:'on-region-6-label',
    107:'on-region-7-label',
    108:'on-region-8-label',
    109:'on-region-9-label',
    110:'on-region-10-label',
    111:'on-region-11-label',
    112:'on-region-12-label',
    113:'on-region-13a-label',
    114:'on-region-13b-label',
    115:'on-region-13c-label',
    201:'nb-region-1-label',
    202:'nb-region-2-label',
    203:'nb-region-3-label',
    204:'nb-region-4-label',
    205:'nb-region-5-label',
    206:'nb-region-6-label',
    207:'nb-region-7-label'
  }

export const REGION_FILTERS = Object.entries(REGION_LABELS).map(([id, text]) => ({ id, text }))